import { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";

const AddDocumentType = ({ setDocuments, setShowModal }) => {
  const [name, setName] = useState("");
  const [documentStatus, setDocumentStatus] = useState("");
  const [appliesTo, setAppliesTo] = useState("");
  const [description, setDescription] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent page reload

    // Basic validation
    if (!name || !appliesTo || !documentStatus) {
      toast.error(
        "Please fill all required fields (Name, Document For, and Status)",
        {
          position: "top-right",
          autoClose: 3000,
        }
      );
      return;
    }

    try {
      const response = await axios.post(
        "https://binberu.idaprocharity.com/api/v1/admin/create-doc-type",
        {
          name,
          description,
          appliesTo, // Fixed: Use documentFor to match Prisma schema
          documentStatus,
        }
      );

      console.log("✅ Document saved:", response.data);
      toast.success("Document created successfully!", {
        position: "top-right",
        autoClose: 3000,
      });

      // Update documents list
      setDocuments((prevDocuments) => [
        ...prevDocuments,
        response.data.data, // Assuming the newly created document is returned in response
      ]);

      // Close the modal (consider delaying if ToastContainer is still in this component)
      // setTimeout(() => setShowModal(false), 1500); // Optional: Delay close by 1.5s to show toast
      setShowModal(false);
    } catch (error) {
      console.error("❌ Error saving document:", error);
      toast.error("Error creating document", {
        position: "top-right",
        autoClose: 3000,
      });
    }
  };

  return (
    <div className="max-w-md mx-auto bg-white p-6 shadow-md rounded-xl">
      <h2 className="text-xl font-semibold mb-4">Add Document</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group mb-4">
          <label htmlFor="name" className="col-form-label">
            Document Name *
          </label>
          <input
            type="text"
            className="form-control"
            id="name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Enter Document Name"
            required
          />
        </div>

        <div className="form-group mb-4">
          <label htmlFor="document_for" className="col-form-label">
            Document For *
          </label>
          <select
            id="document_for"
            name="document_for"
            value={appliesTo}
            onChange={(e) => setAppliesTo(e.target.value)}
            className="form-control"
          >
            <option value="" disabled>
              Select Document For
            </option>
            <option value="DRIVER">Driver</option>
            <option value="VEHICLE">Vehicle</option>
          </select>
        </div>

        <div className="form-group mb-4">
          <label htmlFor="description" className="col-form-label">
            Description
          </label>
          <textarea
            className="form-control"
            rows="3"
            placeholder="Enter description..."
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          ></textarea>
        </div>

        <div className="form-group mb-4">
          <label htmlFor="document_status" className="col-form-label">
            Status *
          </label>
          <select
            id="document_status"
            name="document_status"
            value={documentStatus}
            onChange={(e) => setDocumentStatus(e.target.value)}
            className="form-control"
          >
            <option value="" disabled>
              Select Status
            </option>
            <option value="ACTIVE">Active</option>
            <option value="INACTIVE">Inactive</option>
          </select>
        </div>

        <div className="card-footer d-flex justify-content-between">
          <button type="submit" className="btn btn-primary">
            Submit
          </button>
        </div>
      </form>
      {/* Note: Remove ToastContainer from here. Place it in your root App.js or parent component instead. */}
    </div>
  );
};

export default AddDocumentType;
